"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moment = require("moment");
function nullableString(value) {
    return React.createElement("span", null, value && value !== '' ? value : '-');
}
function boolToString(value) {
    return React.createElement("span", null, value ? 'Yes' : 'No');
}
function dateToDateTimeString(value) {
    return React.createElement("span", null, value ? moment(value).format('lll') : '-');
}
function dateToDateString(value) {
    return React.createElement("span", null, value ? moment(value).format('ll') : '-');
}
function extractFieldValue(fieldName, defaultValue = '') {
    return function (value) {
        const fieldValue = value && value.fieldName ? value.fieldName : defaultValue;
        return React.createElement("span", null, String(fieldValue));
    };
}
exports.AntTableFormatters = {
    boolToString,
    dateToDateTimeString,
    dateToDateString,
    extractFieldValue,
    nullableString
};
//# sourceMappingURL=AntTableFomatters.js.map